export default __webpack_public_path__ + "static/media/EurekaJohn.b9607cd5.PNG";